import React, { useEffect, useState } from 'react'
import $ from 'jquery'


function VisitorCount() {

    const [visitorCount, setVisitorCount] = useState('');
    const countEl = document.getElementById('count');
    useEffect(() => {
        updateVisitCount();
    }, [countEl]) // eslint-disable-line react-hooks/exhaustive-deps

    function updateVisitCount(){
        fetch('https://api.countapi.xyz/update/florin-popcom/codepen/?amount=1')
            .then(res => res.json())
            .then(res => {
                if (countEl != null) {
                    countEl.innerHTML = res.value;
                    setVisitorCount(res.value - 449000);
                }
            })
    }

    $(document).ready(function () {

        $('.counter').each(function () {
            $(this).prop('Counter', 0).animate({
                Counter: $(this).text()
            }, {
                duration: 2000,
                easing: 'swing',
                step: function (now) {
                    $(this).text(Math.ceil(now));
                }
            });
        });

    });



    return (
        <div>
            <div class="counter-box colored" style={{borderStyle:'solid',borderColor:'white',borderWidth:'5px'}}> <i class="fa fa-thumbs-o-up"></i> <span id="count" class="counter" style={{color:'black'}}>{visitorCount}</span>
                <p style={{fontSize:'25px',color:'black'}}><b>Visitors Count</b></p>
            </div>
        </div>
    )
}

export default VisitorCount;
